import React from 'react'
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { purposedocuments as documents  , PurposeCheckBoxData as checkBoxData} from './documents';
import { useFormik } from 'formik';
import CustomInput from '../../../Components/InputCompo/CustomInput';
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import CustomSelection from '../../../Components/SelectionComp/CustomSelection';
import { Button } from '@mui/material';
import { InputCompo } from '../../../Components/InputCompo/InputCompo';
import MultipleSelect from '../../../Components/SelectionComp/MultipleSelect';
import { CreateAccountGet } from '../../../Store/auth/createAccount';
import { useQuery } from '@tanstack/react-query';


const EditPurposeInterestsNotifications = ({setActiveStep}) => {
    const navigate = useNavigate();

  const savedData = JSON.parse(localStorage.getItem("createAccount"));

  localStorage.setItem("dummyEmail", savedData?.email_id);

  const email = localStorage.getItem("dummyEmail");
  console.log(email);

  const { isLoading: fieldLoading, data: questions } = useQuery({
    queryKey: "createAccount",
    queryFn: () => CreateAccountGet(email ? email : ""),
    cacheTime: 1000 * 60 * 5,
    staleTime: 0,
  });
  const multiSelectedValues = (name, question_no, value, setFieldValue) => {
    setFieldValue(name, value);
  };

  const modelSchema = Yup.object().shape(
    documents.reduce((schema, field) => {
      if (field.mandatory === 1 && field.type.toLowerCase() !== "section") {
        let validator = Yup.string().required(`${field.question} is required`);
        if (field.validation) {
          switch (field.validation.toLowerCase()) {
            case "email":
              validator = Yup.string()
                .email("Invalid email address")
                .required(`${field.question} is required`);
              break;
            case "number":
              validator = Yup.string()
                .matches(/^\d{10}$/, "Invalid Number. It should be 10 digit.")
                .required(`${field.question} is required`);
              break;

            default:
              break;
          }
        }

        schema[field.question_no] = validator;
      }

      return schema;
    }, {})
  );

  const formik = useFormik({
    initialValues:
      fieldLoading || !questions || !questions.documents
        ? {
            // Default values when no API data is available (localStorage fallback)
            ...documents.reduce((values, field) => {
              const savedData =
                JSON.parse(localStorage.getItem("createAccount")) || {};
              values[field.question_no] = savedData[field.question_no] || "";
              return values;
            }, {}),
            ...checkBoxData.reduce((values, checkbox) => {
              const savedData =
                JSON.parse(localStorage.getItem("createAccount")) || {};

              if (savedData[checkbox.name] === 1) {
                values[checkbox.name] = true;
              } else if (savedData[checkbox.name] === 0) {
                values[checkbox.name] = false;
              } else {
                values[checkbox.name] = false;
              }

              if (checkbox.isCustomInput) {
                values[checkbox.name] = savedData[checkbox.name] || "";
              }

              // Handle array fields from localStorage
              if (
                checkbox.name === "beneficiary_groups" ||
                checkbox.name === "thematic_area"
              ) {
                const savedValue = savedData[checkbox.name];

                values[checkbox.name] =
                  typeof savedValue === "string"
                    ? savedValue.split(",").map((item) => item.trim())
                    : Array.isArray(savedValue)
                    ? savedValue
                    : [];
              }

              if (checkbox.Geography) {
                checkbox.Geography.forEach((geoItem) => {
                  values[geoItem.name] = savedData[geoItem.name] === 1;

                  if (geoItem.isCustomInput) {
                    const savedValue = savedData[geoItem.name];

                    values[geoItem.name] =
                      typeof savedValue === "string"
                        ? savedValue.split(",").map((item) => item.trim())
                        : Array.isArray(savedValue)
                        ? savedValue
                        : [];
                  }
                });
              }

              return values;
            }, {}),
          }
        : {
            // API data available case - add split functionality here
            ...Object.entries(questions.documents).reduce(
              (acc, [key, value]) => {
                // Handle multiselect fields from API data
                if (
                  key === "beneficiary_groups" ||
                  key === "thematic_area" ||
                  key === "district" ||
                  key === "geography_state"
                ) {
                  acc[key] =
                    typeof value === "string"
                      ? value
                          .split(",")
                          .filter((item) => item.trim() !== "")
                          .map((item) => item.trim()) // Remove empty strings before mapping
                      : Array.isArray(value)
                      ? value
                      : [];
                } else {
                  acc[key] = value;
                }
                return acc;
              },
              {}
            ),
          },

    validationSchema: modelSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        // Convert the form data into a flat object
        const tempData = {
          ...documents.reduce((acc, field) => {
            if (field.isMultiSelect) {
              // Convert array values to a comma-separated string
              acc[field.question_no] = Array.isArray(values[field.question_no])
                ? values[field.question_no].join(", ")
                : values[field.question_no] || "";
            } else {
              acc[field.question_no] = values[field.question_no];
            }
            return acc;
          }, {}),
          ...checkBoxData.reduce((acc, checkbox) => {
            if (checkbox.isCustomInput) {
              acc[checkbox.name] = values[checkbox.name];
            } else if (checkbox.Geography) {
              checkbox.Geography.forEach((geoItem) => {
                if (geoItem.isCustomInput) {
                  acc[geoItem.name] = values[geoItem.name];
                } else {
                  acc[geoItem.name] = values[geoItem.name] ? "1" : "0";
                }
              });
            } else {
              acc[checkbox.name] = values[checkbox.name] ? "1" : "0";
            }
            return acc;
          }, {}),
        };

        // Convert specific multiselect fields from API data
        const multiSelectFields = [
          "beneficiary_groups",
          "thematic_area",
          "district",
          "geography_state",
        ];
        multiSelectFields.forEach((field) => {
          if (Array.isArray(values[field])) {
            tempData[field] = values[field].join(", ");
          }
        });

        // Retrieve existing data from localStorage
        const existingData =
          JSON.parse(localStorage.getItem("createAccount")) || {};

        // Merge new data with existing data
        const updatedData = {
          ...existingData,
          ...tempData,
        };

        // Save updated data to localStorage
        localStorage.setItem("createAccount", JSON.stringify(updatedData));

        console.log("updatedData", updatedData);

        setActiveStep(2);

        // Optionally, navigate to the next page or perform another action
      } catch (error) {
        console.error(error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  return (
    <div>
          <form
            action=""
            onSubmit={formik.handleSubmit}
            className="flex gap-3 flex-col mt-5 mb-20"
          >
            <div className="">
              <ParagraphComp
                className="font-bold text-lg"
                text="Your purpose of using GuideStar India"
              />
            </div>
            <div className="">
              <ParagraphComp
                className="font-medium text-sm"
                text="(Select all options of interest to you)"
              />
            </div>
    
            <div className="w-[100%] flex gap-[24pt] flex-wrap my-3">
              {checkBoxData.slice(0, 8).map((item, index) => (
                <div className="w-[35%] flex gap-[24pt]" key={index}>
                  {!item.isCustomInput && (
                    <div className="w-[100%]">
                      <label className="flex items-center space-x-2">
                        <InputCompo
                          className="bg-[#004878] text-white w-[20px] h-[20px]"
                          type="checkbox"
                          name={item.name}
                          checked={formik.values[item.name]}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <span className="text-black">{item.label}</span>
                      </label>
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={formik.touched[item.name] && formik.errors[item.name]}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
    
            <div className="w-[100%] flex gap-[24pt] flex-wrap my-3">
              <div className="">
                <ParagraphComp
                  className="font-bold text-lg"
                  text="Areas of Interest"
                />
              </div>
    
              <div className="w-[100%]">
                <div className="border-1 border-gray-200 w-[100%] p-3 rounded-t-lg">
                  <div className="">
                    <ParagraphComp
                      className="font-bold text-lg"
                      text="Thematic Area"
                    />
                  </div>
                </div>
                <div className="border-1 border-gray-200 w-[100%] p-3 rounded-b-lg">
                  {checkBoxData.slice(8, 9).map((item, index) => (
                    <div className="w-[100%] flex gap-[24pt]" key={index}>
                      {item.isCustomInput && (
                        <div className="w-[100%]">
                          <label className="flex items-center space-x-2">
                            {/* <InputCompo 
                                        className='bg-[#004878] text-white w-[20px] h-[20px]' 
                                        type='checkbox' 
                                        name={item.name}
                                        checked={formik.values[item.name]} 
                                        onChange={formik.handleChange} 
                                        onBlur={formik.handleBlur} 
                                    /> */}
                            <MultipleSelect
                              {...formik.getFieldProps(item.name)}
                              name={item.name}
                              options={item?.options}
                              label={item.label}
                              mappingKey="option"
                              formik={formik}
                              // Add this to ensure proper value display
                              renderValue={(selected) => selected.join(", ")}
                            />
                          </label>
                          <ParagraphComp
                            className="text-[red] text-[10px] px-[8px] mt-1"
                            text={
                              formik.touched[item.name] && formik.errors[item.name]
                            }
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
    
              <div className="w-[100%]">
                <div className="border-1 border-gray-200 w-[100%] p-3 rounded-t-lg">
                  <div className="">
                    <ParagraphComp
                      className="font-bold text-lg"
                      text="Select State(s)/ District(s) that is of interest to you"
                    />
                  </div>
                </div>
                <div className="border-1 border-gray-200 w-[100%] p-3 rounded-b-lg">
                  {checkBoxData.slice(9, 10).map((item, index) => (
                    <div key={index} className="flex justify-between">
                      {item.Geography.map((geoItem, i) => {
                        const selectedState = formik.values.geography_state || []; // assuming it's a multi-select
                        const isDistrictField = geoItem.name === "district";
    
                        // Filter district options if current field is district
                        const districtOptions = isDistrictField
                          ? geoItem.options.filter((opt) =>
                              selectedState.includes(opt.value)
                            )
                          : geoItem.options;
    
                        return (
                          <div key={i} className="w-[47%]">
                            <label className="flex items-center space-x-2">
                              {/* <InputCompo
                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                        type="checkbox"
                                        name={geoItem.name}
                                        checked={formik.values[geoItem.name]}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        /> */}
                              <MultipleSelect
                                {...formik.getFieldProps(geoItem.name)}
                                name={geoItem.name}
                                options={districtOptions}
                                label={geoItem.label}
                                onBlur={formik.handleBlur}
                                formik={formik}
                                mappingKey="option"
                                renderValue={(selected) => selected.join(", ")}
                              />
                            </label>
                            <ParagraphComp
                              className="text-[red] text-[10px] px-[8px] mt-1"
                              text={
                                formik.touched[geoItem.name] &&
                                formik.errors[geoItem.name]
                              }
                            />
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </div>
    
              <div className="w-[100%]">
                <div className="border-1 border-gray-200 w-[100%] p-3 rounded-t-lg">
                  <div className="">
                    <ParagraphComp
                      className="font-bold text-lg"
                      text="Beneficiary Groups"
                    />
                  </div>
                </div>
                <div className="border-1 border-gray-200 w-[100%] p-3 rounded-b-lg">
                  {checkBoxData.slice(10, 11).map((item, index) => (
                    <div className="w-[100%] flex gap-[24pt]" key={index}>
                      {item.isCustomInput && (
                        <div className="w-[100%]">
                          <label className="flex items-center space-x-2">
                            {/* <InputCompo 
                                        className='bg-[#004878] text-white w-[20px] h-[20px]' 
                                        type='checkbox' 
                                        name={item.name}
                                        
                                        checked={formik.values[item.name]} 
                                        onChange={formik.handleChange} 
                                        onBlur={formik.handleBlur} 
                                    /> */}
                            <MultipleSelect
                              {...formik.getFieldProps(item.name)}
                              name={item.name}
                              options={item?.options}
                              label={item.label}
                              onBlur={formik.handleBlur}
                              formik={formik}
                              mappingKey="option"
                              renderValue={(selected) => selected.join(", ")}
                            />
                          </label>
                          <ParagraphComp
                            className="text-[red] text-[10px] px-[8px] mt-1"
                            text={
                              formik.touched[item.name] && formik.errors[item.name]
                            }
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
    
            <div className="my-3">
              <ParagraphComp
                className="font-bold text-lg"
                text="Foreign Contribution"
              />
            </div>
    
            <div className="flex flex-wrap gap-[30px] justify-between w-[100%] mt-2">
              {documents?.slice(0, 1).map((Fields) => (
                <>
                  {Fields.type.toLowerCase() === "dropdown" ? (
                    <div className="w-[100%]">
                      <>
                        <CustomSelection
                          noSort={true}
                          options={Fields?.options}
                          {...formik?.getFieldProps(Fields?.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                        />
                        {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                        <ParagraphComp
                          className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                          text={Fields.description}
                        />{" "}
                      </>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>
    
            <div className="my-3">
              <ParagraphComp
                className="font-bold text-lg"
                text="Updates & Notifications"
              />
            </div>
            <div className="flex flex-wrap gap-[30px] justify-between w-[100%] ">
              {documents?.slice(1, 2).map((Fields) => (
                <>
                  {Fields.type.toLowerCase() === "text" ||
                  Fields.type.toLowerCase() === "number" ||
                  Fields.type.toLowerCase() === "email" ? (
                    <div className="w-[100%]">
                      <CustomInput
                        {...formik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no}
                        label={Fields.question}
                        onBlur={formik.handleBlur}
                      />
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          formik.values?.[Fields.question_no] &&
                          formik.errors?.[Fields.question_no]
                        }
                      />
                      <ParagraphComp
                        className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                        text={Fields.description}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>
    
            <div className="w-[100%] flex gap-[24pt] flex-wrap my-3">
              {checkBoxData.slice(11, 12).map((item, index) => (
                <div className="w-[35%] flex gap-[24pt]" key={index}>
                  {!item.isCustomInput && (
                    <div className="w-[100%]">
                      <label className="flex items-center space-x-2">
                        <InputCompo
                          className="bg-[#004878] text-white w-[20px] h-[20px]"
                          type="checkbox"
                          name={item.name}
                          checked={formik.values[item.name]}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <span className="text-black">{item.label}</span>
                      </label>
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={formik.touched[item.name] && formik.errors[item.name]}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
    
            <div className="flex justify-end">
              <div className="flex gap-[20px]">
                {/* <Button onClick={() => navigate(-1)} variant='text' disableRipple sx={{color:'#C00000' , fontWeight:600 , textTransform:'inherit' , letterSpacing:'-.5px' , fontSize:'14px'}}>Cancel</Button> */}
                <Button
                  onClick={() => setActiveStep(0)}
                  variant="text"
                  disableRipple
                  sx={{
                    color: "#C00000",
                    fontWeight: 600,
                    textTransform: "inherit",
                    letterSpacing: "-.5px",
                    fontSize: "14px",
                  }}
                >
                  Back
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: "#C00000",
                    color: "white",
                    borderRadius: "20px",
                    fontWeight: 600,
                    textTransform: "inherit",
                    letterSpacing: "-.5px",
                    fontSize: "14px",
                    "&:hover": { backgroundColor: "#ED1C24" },
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </div>
            {/* {questions && (
              <div className="flex justify-end mt-2">
                <div className="flex gap-[20px]">
                  <Button
                    onClick={() => setActiveStep(3)}
                    variant="contained"
                    sx={{
                      backgroundColor: "#004878",
                      color: "white",
                      borderRadius: "20px",
                      fontWeight: 600,
                      textTransform: "inherit",
                      padding: "5px 30px",
                      letterSpacing: "-.5px",
                      fontSize: "14px",
                      "&:hover": { backgroundColor: "#004878" },
                    }}
                  >
                    Register Offer/ Event
                  </Button>
                </div>
              </div>
            )} */}
          </form>
        </div>
  )
}

export default EditPurposeInterestsNotifications